import createSizePropertyCheck from './_createSizePropertyCheck.js';
import getByteLength from './_getByteLength.js';

// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
export default createSizePropertyCheck(getByteLength);



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_isBufferLike.js
// module id = F8Q8
// module chunks = 0